module.exports = __webpack_public_path__ + "static/mulher-cubo-flutuando-461f9df28372c9b6ce65fc80091bd053.png";